export function tabbedContent(container){
    if(container){
        const tabs = container.querySelectorAll('.btn-tab');
        const tabPanels = container.querySelectorAll('.tab-panel');
        const mobileTab = container.querySelector('.dropdown-toggle');

        tabs[0].classList.add('active');
        tabPanels[0].classList.add('active');

        for(let i = 0; i < tabs.length; i++){
            const target = tabs[i].dataset.tab;

            tabs[i].addEventListener('click', (e) => {
                e.preventDefault();

                clearSelection(tabs);
                clearSelection(tabPanels);

                tabs[i].classList.add('active');
                mobileTab.textContent = tabs[i].textContent;

                container.querySelector('.tab-panel[data-tab="'+target+'"]').classList.add('active');

                console.log(target);
            });
        }
    }
}

function clearSelection(items){
    for(let i = 0; i < items.length; i++){
        items[i].classList.remove('active');
    }
}